// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Setting__divider-b63c09 {
  width: 100%;
  height: 9px;
  background-color: var(--base-15);
}

.Setting__popover-e0bf3c {
  max-width: 340px;
  min-width: 340px;
  box-sizing: border-box;
}`, "",{"version":3,"sources":["webpack://./src/main/Calendar/Content/Toolbar/Setting/Setting.styles.m.css"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,WAAA;EACA,gCAAA;AACF;;AAEA;EACE,gBAAA;EACA,gBAAA;EACA,sBAAA;AACF","sourcesContent":[".divider {\n  width: 100%;\n  height: 9px;\n  background-color: var(--base-15);\n}\n\n.popover {\n  max-width: 340px;\n  min-width: 340px;\n  box-sizing: border-box;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"divider": `Setting__divider-b63c09`,
	"popover": `Setting__popover-e0bf3c`
};
module.exports = ___CSS_LOADER_EXPORT___;
